// statementStatus.js — single source of truth for invoice-statement reconciliation
// status. BOTH the tile grid (apps/InvoiceStatements.jsx) and the table view
// (tableConfigs/invoiceStatements.js) derive and render from this one map, so the
// two views always show the identical icon, colour and label. Status is shown as
// an ICON, not a pill — pills are reserved for interactive controls (buttons,
// filter chips). If you change an icon/colour here, both views move together.
import { FaCheckCircle, FaMinusCircle, FaTimesCircle, FaRegCircle } from "react-icons/fa";

// key -> { icon, color, label, title, rank }
//   rank orders the column sort: blocked (0) first … reconciled (4) last.
export const STATEMENT_STATUS = {
   blocked:    { icon: FaTimesCircle, color: "#dc3545", label: "Blocked",    title: "Reconciliation blocked – requires setup", rank: 0 },
   pending:    { icon: FaRegCircle,   color: "#6c757d", label: "Pending",    title: "No reconciled invoices",                  rank: 1 },
   partial:    { icon: FaMinusCircle, color: "#fd7e14", label: "Partial",    title: "Partially reconciled",                    rank: 2 },
   mostly:     { icon: FaMinusCircle, color: "#198754", label: "Mostly",     title: "Mostly reconciled",                       rank: 3 },
   reconciled: { icon: FaCheckCircle, color: "#198754", label: "Reconciled", title: "Fully reconciled",                        rank: 4 },
};

// Single derivation shared by both views. Pass the statement state plus the raw
// invoice/match counts; field-name mapping stays at the call site.
export function deriveStatementStatus({ statementState, invoiceCount, matchCount }) {
   if (statementState === "SETUP" || statementState === "BLOCKED") return "blocked";
   const inv = Number(invoiceCount) || 0;
   const matched = Number(matchCount) || 0;
   if (!inv) return "pending";
   if (matched === inv) return "reconciled";
   if (matched >= inv * 0.75) return "mostly";
   if (matched > 0) return "partial";
   return "pending";
}

// Returns the meta for a status key, falling back to `pending` for anything unknown.
export const statementStatusMeta = (key) => STATEMENT_STATUS[key] || STATEMENT_STATUS.pending;
